import React from 'react'

export function useOptionalHook<T = any>(
    initialValue: T,
    setValue: React.Dispatch<React.SetStateAction<T>> | undefined,
) {
    const [value, setValueState] = React.useState<T>(initialValue)

    function setValueHandler(valueOrUpdater: React.SetStateAction<T>) {
        setValueState(valueOrUpdater)
        setValue?.(valueOrUpdater)
    }

    return [value, setValueHandler] as const
}
